import { render, staticRenderFns } from "./OutboundEmailHeaderInfo.vue?vue&type=template&id=4cf18ea1&scoped=true&"
import script from "./OutboundEmailHeaderInfo.vue?vue&type=script&lang=ts&"
export * from "./OutboundEmailHeaderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OutboundEmailHeaderInfo.vue?vue&type=style&index=0&id=4cf18ea1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf18ea1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
